import api from "../api";

// The staff app's one background poll (backend GET /pulse): unread patient
// messages, due follow-ups, my alerts, crisis alerts sent to me and
// supervision about to start, all in one call. Anything new that needs
// "keep checking" should be added to /pulse and read from here, not given
// its own setInterval.
//
// Module-level, so the layout's two header copies and every page's own
// layout share one timer. Open tabs share one poll too: whichever tab's
// timer fires first polls and passes the result to the others over a
// BroadcastChannel, so five tabs cost one call, and a tab in the background
// still gets the patient-waiting pop-up and crisis siren.
const POLL_MS = 30000;
const LAST_KEY = "pulse_last_poll_at";

const store = { data: null, owner: null, listeners: new Set(), timer: null };
const login = () => {
  try { return localStorage.getItem("auth"); } catch { return null; }
};
const publish = (data) => {
  store.data = data;
  store.owner = login();
  store.listeners.forEach((fn) => fn(data));
};

let channel = null;
try {
  channel = new BroadcastChannel("staff_pulse");
  channel.onmessage = (e) => { if (e.data && e.data.owner === login()) publish(e.data.data); };
} catch { /* old browser: each tab polls for itself */ }

const lastPoll = () => {
  try { return Number(localStorage.getItem(LAST_KEY)) || 0; } catch { return 0; }
};

// force: poll now (after the user changed something, e.g. read an alert).
// Otherwise skip when another tab polled recently; its result arrives here.
export function refreshPulse(force = true) {
  if (!force && channel && Date.now() - lastPoll() < POLL_MS - 2000) return;
  try { localStorage.setItem(LAST_KEY, String(Date.now())); } catch { /* private mode */ }
  api.getPulse()
    .then((r) => {
      const data = r.data || {};
      publish(data);
      try { channel && channel.postMessage({ owner: login(), data }); } catch { /* closed */ }
    })
    .catch(() => {});
}

const onVisible = () => { if (document.visibilityState === "visible") refreshPulse(false); };

export function subscribePulse(fn) {
  if (store.owner !== login()) store.data = null; // someone else logged in on this browser
  store.listeners.add(fn);
  if (store.data) fn(store.data);
  if (!store.timer) {
    refreshPulse(!store.data);
    store.timer = setInterval(() => refreshPulse(false), POLL_MS);
    document.addEventListener("visibilitychange", onVisible);
  }
  return () => {
    store.listeners.delete(fn);
    if (store.listeners.size === 0) {
      clearInterval(store.timer);
      store.timer = null;
      document.removeEventListener("visibilitychange", onVisible);
    }
  };
}
